import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetExpenseQuery,
  useRemoveExpenseMutation,
} from "../../features/api/expenseApi";
import { formatDate } from "../../components/CommonDateFormat";
import { useGetAllModelQuery } from "../../features/api/modelApi";

const ExpenseSummary = () => {
  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const { data, isLoading } = useGetExpenseQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const expenses = data?.expense;

  const sortedPurchase = expenses?.slice().sort((a, b) => b?.id - a?.id);

  const [removeExpense] = useRemoveExpenseMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeExpense(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = expenses?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-xl font-bold">Expense Info</h1>
        <Link
          to="/dashboard/expenses/create"
          className="flex items-center p-1 text-white bg-blue-500"
        >
          {" "}
          <span className="  font-bold cursor-pointer">
            <MdAdd className="text-xl text-white bg-blue-500 " />
          </span>
          <span> New Expense</span>
        </Link>
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="py-4">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : expenses?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no expense summary
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Expense no.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Date</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Particular</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Expense Month</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Amount</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold text-center">Remarks</span>
                  </TableCell>
                  {/* <TableCell>
                    <span className="font-bold">Action</span>
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    const proName = productModels?.find(
                      (pro) => pro?.model_id === row?.part
                    );

                    return (
                      <TableRow key={row?.id}>
                        <TableCell>{row?.exp_no}</TableCell>
                        <TableCell>{formatDate(row?.exp_date)}</TableCell>
                        <TableCell>{proName?.model_name}</TableCell>
                        <TableCell>
                          {row?.qty === 1
                            ? "January"
                            : row?.qty === 2
                            ? "February"
                            : row?.qty === 3
                            ? "March"
                            : row?.qty === 4
                            ? "April"
                            : row?.qty === 5
                            ? "May"
                            : row?.qty === 6
                            ? "June"
                            : row?.qty === 7
                            ? "July"
                            : row?.qty === 8
                            ? "August"
                            : row?.qty === 9
                            ? "September"
                            : row?.qty === 10
                            ? "October"
                            : row?.qty === 11
                            ? "November"
                            : "December"}
                        </TableCell>
                        <TableCell>{row?.exp_amt}</TableCell>
                        <TableCell>{row?.rmk}</TableCell>
                        {/* <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            
                            <span onClick={() => handleDelete(row?.id)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span>
                          </div>
                        </TableCell> */}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[30, 50, 100]}
              component="div"
              count={expenses?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default ExpenseSummary;
